import { SelectOption } from '../../../../CommonComponents/Select';

export const incomeOpts = [
  {
    label: 'Between $0 and $25,000',
    value: { min: 0, max: 25_000 },
  },
  {
    label: 'Between $25,001 and $50,000',
    value: { min: 25_001, max: 50_000 },
  },
  {
    label: 'Between $50,001 and $100,000',
    value: { min: 50_001, max: 100_000 },
  },
  {
    label: 'Between $100,001 and $200,000',
    value: { min: 100_001, max: 200_000 },
  },
  {
    label: 'Between $200,001 and $300,000',
    value: { min: 200_001, max: 300_000 },
  },
  {
    label: 'Between $300,001 and $500,000',
    value: { min: 300_001, max: 500_000 },
  },
  {
    label: 'Between $500,001 and $1,200,000',
    value: { min: 500_001, max: 1_200_000 },
  },
  {
    label: '$1,200,001 or greater',
    value: { min: 1_200_001, max: 9_999_999 },
  },
];

export const netWorthOpts = [
  {
    label: 'Between $0 and $50,000',
    value: { min: 0, max: 50_000 },
  },
  {
    label: 'Between $50,001 and $100,000',
    value: { min: 50_001, max: 100_000 },
  },
  {
    label: 'Between $100,001 and $200,000',
    value: { min: 100_001, max: 200_000 },
  },
  {
    label: 'Between $200,001 and $500,000',
    value: { min: 200_001, max: 500_000 },
  },
  {
    label: 'Between $500,001 and $1,000,000',
    value: { min: 500_001, max: 1_000_000 },
  },
  {
    label: 'Between $1,000,001 and $5,000,000',
    value: { min: 1_000_001, max: 5_000_000 },
  },
  {
    label: '$5,000,001 or greater',
    value: { min: 5_000_001, max: 9_999_999 },
  },
];

export const getIncomeOption = (
  valueMin: number | null,
  valueDefault: number | null,
  options: SelectOption<{ min: number; max: number }>[],
): SelectOption<{ min: number; max: number }> => {
  // If we have a min value set already (e.g. annualIncomeUSDMin) ➜ get the corresponding option
  // If not, use the default value (from the BE)
  if (typeof valueMin === 'number' || typeof valueDefault === 'number') {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const value = typeof valueMin === 'number' ? valueMin : valueDefault!;

    // Value larger than the max allowed by Apex (aka 9,999,999)
    if (value > 9_999_999) {
      return options[options.length - 1];
    }

    for (let i = 0; i < options.length; i += 1) {
      const {
        value: { min, max },
      } = options[i];

      if (value >= min && value <= max) {
        return options[i];
      }
    }
  }

  return options[0];
};
